import { useEffect } from 'react';

import { useFormikContext } from 'formik';

export const ScrollToError = () => {
  const formik = useFormikContext();

  useEffect(() => {
    if (!formik.isSubmitting) return;
    if (Object.keys(formik.errors).length > 0) {
      document.querySelector('.error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [formik]);

  return <></>;
};
